import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, HostBinding, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnalyticsService } from '@app/services/analytics.service';
import { ProductSiteRegionService } from '@app/services/product-site-region.service';
import { NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MainComponent implements OnInit, OnDestroy {

    productInformationList: Array<any> = [];
    assayList: Array<any> = [];
    private queryParamsSubscription: Subscription;

    @ViewChild('modalContainer', { static: true }) modalContainer: ElementRef<HTMLDivElement>;

    @HostBinding('class.taqman-iu') tq: boolean = true;
    @HostBinding('class.fisher') isFisherSci: boolean = false;

    constructor (
        @Inject(DOCUMENT) private document: Document,
        private analyticsService: AnalyticsService,
        private route: ActivatedRoute,
        private productSiteRegionService: ProductSiteRegionService,
        private ngbModalConfig: NgbModalConfig
    ) {}

    ngOnInit(): void {

        this.ngbModalConfig.container = this.modalContainer.nativeElement;

        if ( this.productSiteRegionService.isFisherSci() ) {
            this.isFisherSci = true;
        }

        this.productInformationList.push({
            assayDetail: [
                {
                    displayName: "Assay ID",
                    displayValue: "Hs01034249_m1",
                }, {
                    displayName: "Best coverage",
                    displayValue: "Yes",
                },
                {
                    displayName: "Availability",
                    displayValue: "Inventoried",
                },
                {
                    displayName: "Gene symbol",
                    displayValue: "TPS3",
                },
                {
                    displayName: "Species",
                    displayValue: "human",
                },
                {
                    displayName: "Amplicon length",
                    displayValue: "127",
                },
                {
                    displayName: "3' Most Assay",
                    displayValue: "3",
                },
                {
                    displayName: "Transcript type",
                    displayValue: "Coding",
                },
                {
                    displayName: "Assay design",
                    displayValue: "Probe spans exons",
                },
                {
                    displayName: "RefSeq coverage",
                    displayValue: ["NM_000546.5 (10-11)", "NM_001126112.2 (10-11)", "NM_001126113.2 (11-12)",
                        "NM_001126114.2 (11-12)", "NM_001126115.1 (6-7)"],
                }
            ]
        });
        this.productInformationList.push({
            assayDetail: [
                {
                    displayName: "Assay ID",
                    displayValue: "Hs01556193_m1",
                }, {
                    displayName: "Best Coverage",
                    displayValue: "NO",
                },
                {
                    displayName: "Availability",
                    displayValue: "Inventoried",
                },
                {
                    displayName: "Species",
                    displayValue: "human",
                },
                {
                    displayName: "Gene symbol",
                    displayValue: "TPS3",
                },
                {
                    displayName: "Amplicon Length",
                    displayValue: "127",
                },
                {
                    displayName: "3' Most Assay",
                    displayValue: "3",
                },
                {
                    displayName: "Transcript Type",
                    displayValue: "Coding",
                },
                {
                    displayName: "Assay Design",
                    displayValue: "Probe spans exons",
                },
                {
                    displayName: "RefSeq coverage",
                    displayValue: ["NM_000546.5 (11-11)", "NM_001126112.2 (11-11)", "NM_001126113.2 (12-12)",
                        "NM_001126114.2 (12-12)", "NM_001126115.1 (7-7)"],
                }
            ]
        });
        this.productInformationList.push({
            assayDetail: [
                {
                    displayName: "Assay ID",
                    displayValue: "DAE43435",
                }, {
                    displayName: "Best Coverage",
                    displayValue: "YES3",
                },
                {
                    displayName: "Availability",
                    displayValue: "Inventoried",
                },
                {
                    displayName: "Gene symbol",
                    displayValue: "TPS3",
                },
                {
                    displayName: "Species",
                    displayValue: "human",
                },
                {
                    displayName: "Amplicon Length",
                    displayValue: "127",
                },
                {
                    displayName: "3' Most Assay",
                    displayValue: "3",
                },
                {
                    displayName: "Transcript Type",
                    displayValue: "Coding",
                },
                {
                    displayName: "Assay Design",
                    displayValue: "Probe spans exons",
                },
                {
                    displayName: "RefSeq coverage",
                    displayValue: ["NM_000546.5 (11-11)", "NM_001126112.2 (11-11)", "NM_001126113.2 (12-12)",
                        "NM_001126114.2 (12-12)", "NM_001126115.1 (7-7)"],
                }
            ]
        });


        this.assayList.push({
            assayDetail: [
                {
                    displayName: "assayId",
                    displayValue: "Hs01034249_m1"
                }, {
                    displayName: "price",
                    displayValue: "USD 9334.67"
                }

                ,
                {
                    displayName: "catalog",
                    displayValue: "Catalog #335343"
                }
                , {
                    displayName: "size",
                    displayValue: "S: 250 rxns"
                }
                , {
                    displayName: "dye",
                    displayValue: "FAM/MGB-NFQ"
                }
            ]
        });
        this.assayList.push({
            assayDetail: [
                {
                    displayName: "assayId",
                    displayValue: "Hs01556193_m1"
                }, {
                    displayName: "price",
                    displayValue: "USD 222.67"
                },
                {
                    displayName: "catalog",
                    displayValue: "Catalog #335343"
                }
                , {
                    displayName: "size",
                    displayValue: "S: 250 rxns"
                }
                , {
                    displayName: "dye",
                    displayValue: "FAM/MGB-NFQ"
                }
            ]
        });
        this.assayList.push({
            assayDetail: [
                {
                    displayName: "assayId",
                    displayValue: "Hs01556194_m1"
                }, {
                    displayName: "price",
                    displayValue: "USD 344.23"
                }
                ,
                {
                    displayName: "catalog",
                    displayValue: "Catalog #336343"
                }
                , {
                    displayName: "size",
                    displayValue: "S: 250 rxns"
                }
                , {
                    displayName: "dye",
                    displayValue: "FAM/MGB-NFQ"
                }
            ]
        });
        this.analyticsService.triggerAnalyticsOnLoad('taqman search results:gene expression');
        this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
            if (params['customArray'] === "true") {
                document.getElementsByTagName("meta")["viewport"].content = "";
            }
        });
    }

    ngOnDestroy(): void {
        this.queryParamsSubscription.unsubscribe();
    }

}
